import safeFetch from '../../utils/safeFetch';

const reactivateOldBasketByUrl = (url) => {
  return new Promise((resolve, reject) => {
    safeFetch(url, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.status === 1) {
          resolve(data);
        } else {
          console.error('Could not reactivate old basket.', data);
          reject(data);
        }
      })
      .catch((error) => {
        console.error('Could not reactivate old basket.', error);
        reject(error);
      });
  });
};

export default reactivateOldBasketByUrl;
